export const BookMark = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				d="M17 4V10L15 8L13 10V4H9V20H19V4H17ZM3 7V5H5V4C5 2.89 5.9 2 7 2H19C20.05 2 21 2.95 21 4V20C21 21.05 20.05 22 19 22H7C5.95 22 5 21.05 5 20V19H3V17H5V13H3V11H5V7H3ZM5 5V7H7V5H5ZM5 19H7V17H5V19ZM5 13H7V11H5V13Z"
				fill="#7B809A"
			/>
		</svg>
	);
};
